import api from '../../../../api/client'

export const DATE_PERIOD_OPTIONS = [
  { value: 'period', label: 'Period' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'current_week', label: 'Current Week' },
  { value: 'current_month', label: 'Current Month' },
  { value: 'current_year', label: 'Current Year' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_year', label: 'Last Year' },
]

export const SEARCH_FIELD_OPTIONS = [
  { value: 'All', label: 'All Fields' },
  { value: 'Name', label: 'Student Name' },
  { value: 'Roll No', label: 'Roll No / ID Card' },
  { value: 'Device ID', label: 'Device ID' },
  { value: 'Branch', label: 'Branch' },
  { value: 'Company', label: 'Company' },
]

export let COMPANY_OPTIONS = ['All']
export let BRANCH_OPTIONS = ['All']
export let DEVICE_OPTIONS = ['All']

/**
 * Fetch paginated list of biometric swipe card records.
 * Direct live integration with FastAPI GET /admission/biometric.
 */
export async function listBiometricRecords(params = {}) {
  const query = {
    company: params.company || 'All',
    branch: params.branch || 'All',
    course: params.course || 'All',
    batch: params.batch || 'All',
    deviceId: params.deviceId || 'All',
    period: params.period || params.datePeriod || '',
    fromDate: params.fromDate || '',
    toDate: params.toDate || '',
    studentId: params.studentId || undefined,
    searchField: params.searchField || 'All',
    searchText: params.searchText || '',
    orderBy: params.orderBy || 1,
    page: params.page || 1,
    pageSize: params.pageSize || 25,
  }

  const response = await api.get('/admission/biometric', { params: query })
  return response.data || { data: [], total: 0, page: 1, pageSize: 25, totalPages: 1 }
}

/**
 * Fetch summary KPI metrics (totalSwipes, uniqueStudents, activeDevices, todaySwipes).
 * Direct live integration with FastAPI GET /admission/biometric/summary.
 */
export async function getBiometricSummary(params = {}) {
  const query = {
    fromDate: params.fromDate || '',
    toDate: params.toDate || '',
  }
  const response = await api.get('/admission/biometric/summary', { params: query })
  return response.data || { totalSwipes: 0, uniqueStudents: 0, activeDevices: 0, todaySwipes: 0 }
}

/**
 * Fetch distinct filter dropdown options for companies, branches, courses, batches, and biometric devices.
 */
export async function getBiometricOptions() {
  const response = await api.get('/admission/biometric/options')
  const data = response.data || {}

  if (Array.isArray(data.companies) && data.companies.length > 0) {
    COMPANY_OPTIONS = ['All', ...data.companies.filter((c) => c !== 'All')]
  }
  if (Array.isArray(data.branches) && data.branches.length > 0) {
    BRANCH_OPTIONS = ['All', ...data.branches.filter((b) => b !== 'All')]
  }
  if (Array.isArray(data.devices) && data.devices.length > 0) {
    DEVICE_OPTIONS = ['All', ...data.devices.filter((d) => d !== 'All')]
  }

  return {
    companyOptions: COMPANY_OPTIONS,
    branchOptions: BRANCH_OPTIONS,
    deviceOptions: DEVICE_OPTIONS,
    courses: data.courses || [],
    batches: data.batches || [],
  }
}

/** Backward compatibility aliases for existing imports */
export async function getCompanyOptions() {
  const opts = await getBiometricOptions()
  return opts.companyOptions.map((c) => ({ value: c, label: c === 'All' ? 'All Companies' : c }))
}

export async function getBranchOptions() {
  const opts = await getBiometricOptions()
  return opts.branchOptions.map((b) => ({ value: b, label: b === 'All' ? 'All Branches' : b }))
}

/**
 * Manually or device-assisted swipe record creation (AttendanceDAL.cs SaveSwipe).
 */
export async function createBiometricSwipe(payload) {
  const response = await api.post('/admission/biometric', payload)
  return response.data
}
